import {LABELS} from '@github-ui/issues-shared/labels'
import {Heading} from '@primer/react'

import styles from './AppTitle.module.css'

export function AppTitle() {
  return (
    <div className={styles.AppTitleContainer}>
      <Heading id="sidebar-title" as="h2" className={styles.Heading}>
        <span>{LABELS.appHeader}</span>
      </Heading>
    </div>
  )
}
